///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

export class ReleaseNotesTypes {
    public static readonly NEW_RELEASE = 'RELEASE_NOTES_NEW_RELEASE';
    public static readonly LIMITATION = 'RELEASE_NOTES_LIMITATION_AND_ISSUES';
    public static readonly PRODUCT_COMPATIBILITY = 'RELEASE_NOTES_PRODUCT_COMPATIBILITY';
    public static readonly ABOUT_SIKLU = 'ABOUT_SIKLU';

    public static readonly ALL_RELEASE_NOTES = [
        ReleaseNotesTypes.NEW_RELEASE,
        ReleaseNotesTypes.LIMITATION,
        ReleaseNotesTypes.PRODUCT_COMPATIBILITY,
        ReleaseNotesTypes.ABOUT_SIKLU
    ];
}
